/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

export default {
    /**
     * DELETE /api/bookings/{bookingId}/bookingWatchlists/{bookingWatchlistId}
     */
    deleteBookingWatchlist: function( bookingId, bookingWatchlistId ){
        return axios.delete( `/api/bookings/${bookingId}/bookingWatchlists/${bookingWatchlistId}`);
    },

    /**
     * POST /api/bookings/{bookingId}/bookingWatchlists
     */
    postNewBookingWatchlist: function ( bookingId , params ){
        return axios.post(`/api/bookings/${bookingId}/bookingWatchlists`,  params );
    }
}